import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionHistoryPage } from './transaction-history.page';
import { TransactionHistoryRoutingModule } from './transaction-history-routing.module';
import { HistorySidebarItemComponent } from './history-sidebar-item.component';
import { HistorySearchbarComponent } from './history-searchbar.component';
import { HistoryItemHeaderComponent } from './history-item-header.component';
import { HistoryItemArticleComponent } from './history-item-article.component';
import { HistoryItemComponent } from './history-item.component';
import { CoreModule } from '../core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HasNoProductsAvailableToReturnPipe } from './transaction-history.pipe';
import { ProductsModule } from '../products/products.module';
import { ProductReturnsService } from '../product-returns/product-returns.service';

@NgModule({
  declarations: [
    HasNoProductsAvailableToReturnPipe,
    TransactionHistoryPage,
    HistorySidebarItemComponent,
    HistorySearchbarComponent,
    HistoryItemHeaderComponent,
    HistoryItemArticleComponent,
    HistoryItemComponent,
  ],
  imports: [
    TransactionHistoryRoutingModule,
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
    ProductsModule,
  ],
  providers: [
    ProductReturnsService,
  ],
})
export class TransactionHistoryModule { }
